import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import ShipmentsTable from "@/components/logistics/containers/shipments-table";

const consolidadosSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/logistics/containers/_list/",
)({
  validateSearch: consolidadosSearchSchema,
  component: ConsolidadosTablePage,
});

function ConsolidadosTablePage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <ShipmentsTable
        currentPage={searchParams.page}
        pageSize={10}
        basePath="/logistics/containers"
        searchParams={searchParams}
      />
    </div>
  );
}
